import React, { useEffect, useState } from 'react';
import { Container, Form, Button, Card, Image, Navbar, Spinner } from 'react-bootstrap';
import { Link, useHistory, useParams } from 'react-router-dom';
import Logo from "../../beatai-logo.svg";
import { confirmPasswordReset, IS_DEV } from '../../service/api';
import Turnstile, { useTurnstile } from "react-turnstile";

const VerifyOTP = () => {

  useEffect(() => {
    document.title = "BeatAI - Password Change"
 }, []);

 const turnstile = useTurnstile();
 const [CFToken, setCFToken] = useState("");
 const [errorText, setErrorText] = useState("");

  const [formData, setFormData] = useState({
    otp: '',
    newPassword: '',
    confirmPassword: '',
  });

  const [loading , setLoading] = useState(false);

  const { token } = useParams();

  const history = useHistory();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    if (formData.confirmPassword != formData.newPassword) alert("Passwords don't match!")
      confirmPasswordReset(token, formData.newPassword, CFToken).then(async (r) => {
        
        if (!r.ok) {
          setLoading(false);

          const j = await r.json();
          console.log(j)
          if ("error" in j){
              setErrorText(j.error);
              setTimeout(() => {
              setErrorText("")
            }, 3000)
            return
          }
          if ("captcha" in j) {
            setErrorText("Invalid captcha!")
            setTimeout(() => {
              setErrorText("")
            }, 3000)
          } else {
            setErrorText("Technical error!")
            setTimeout(() => {
              setErrorText("")
            }, 3000)
          }
        } else {
          history.push('/login?sc=ef5199c2-e6b8-4257-9932-20aa6f449c90R');
          setLoading(false);
        }

    }).catch((e) => {
      setErrorText("Technical error!")
      setLoading(false);
      setTimeout(() => {
        setErrorText("")
      }, 3000)
    })
  };

  return (
    <>
    <Navbar sticky='top' bg="dark" variant="dark" expand="lg" className="w-100 m-0 nav_">
        <Container fluid className="px-3">
          <Navbar.Brand className="ms-2"><Image src={Logo} style={{ maxWidth: "140px" }} /></Navbar.Brand>
        </Container>
      </Navbar>
    <Container className="d-flex align-items-center justify-content-center vh-100">
      <Card className="border-card-purp dark-theme p-4 auth-card" style={{ width: '400px' }}>
        <Card.Body>
        <h2 className="text-center mb-4">Change Password</h2>
          <p className="text-center mb-4" style={{fontSize: "0.9em"}}>
            We suggest to use a strong password to prevent from account getting stolen.
          </p>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>New Password</Form.Label>
              <Form.Control
                type="password"
                name="newPassword"
                placeholder='Choose new password'
                value={formData.newPassword}
                onChange={handleChange}
                minLength={6}
                className=""
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Confirm New Password</Form.Label>
              <Form.Control
                type="password"
                name="confirmPassword"
                placeholder='Confirm new password'
                value={formData.confirmPassword}
                onChange={handleChange}
                className=""
                required
                minLength={6}
              />
            </Form.Group>
            <Turnstile
                className="turnsite"
                sitekey={IS_DEV? "1x00000000000000000000AA":"0x4AAAAAAA29TKraRXtvC8Rg"}
                size="flexible"
                theme="dark"
                style={{
                  marginBottom: "10px",
                }}
                onVerify={(token) => {
                  setCFToken(token);
                }}
              />
              <p className="text-danger">{errorText}</p>

            <Button disabled={loading} className={"beat-btn-pr w-100"} variant="primary" type="submit" >
              {loading? <Spinner size='sm'/> : "Reset Password"}
            </Button>
          </Form>
          <div className="text-center mt-3 link-a">
            <Link to="/login?sc=ef5199c2-e6b8-4257-9932-20aa6f449c90R">Back to Login</Link>
          </div>
        </Card.Body>
      </Card>
    </Container></>
  );
};

export default VerifyOTP;